export const state = {
  subvenirBesoin: undefined,
  subvenirBesoins: [],
  soussubvenirBesoin: undefined,
  soussubvenirBesoins: []
}